export default __webpack_public_path__ + "static/media/portfolio-84.42721d04.jpg";